import React, {useRef, useEffect} from 'react';
import moment from 'moment';
import {PropTypes} from 'prop-types';
import scheduleUtils from '../scheduleUtils';
import TimePickerComponentRender from './timePickerComponentRender';

const TimePickerComponent = (props) => {
  const {
    isDayEndTimePicker = false,
    selected,
    timeIntervals,
    timeFormat,
    validTimeRanges,
    sessionTimeLimit,
    setfirstAvailableTimeSlot,
    isMentor = false,
    selectedTimezone,
    mentorTimeZone,
    minDate,
  } = props;

  const day = moment(selected).tz(selectedTimezone).date();

  let timesArray = props.availableSlotsListsByDate?.[day]
    ? props.availableSlotsListsByDate[day].map((timeSlot) => timeSlot.time)
    : scheduleUtils.generateTimeIntervals(
        '00:00',
        timeIntervals,
        'minutes',
        timeFormat,
      );
  if (isDayEndTimePicker) {
    timesArray.shift();
  } else {
    timesArray.pop();
  }
  const timeFormatStr = scheduleUtils.getTimeFormatStr(timeFormat);
  useEffect(() => {
    // this will clear Timeout when component unmont like in willComponentUnmount
    scrollToSelectedTime();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.alreadyBookedTimeRanges, validTimeRanges]);

  const isTimeValid = props.availableSlotsListsByDate
    ? (time) => {
        {
          return props.availableSlotsListsByDate[day]?.some(
            (timeSlot) =>
              timeSlot.time === time && timeSlot.availableMentorIds?.length > 0,
          );
        }
      }
    : (time) => {
        if (isMentor) {
          return true;
        }
        const selectedDate = new Date(selected).getDate();

        let alreadyBookedTimeRanges = [];

        if (props.alreadyBookedTimeRanges) {
          if (typeof props.alreadyBookedTimeRanges === 'object') {
            alreadyBookedTimeRanges =
              Object.values(props.alreadyBookedTimeRanges)[0]?.get(
                selectedDate,
              ) || [];
          } else {
            alreadyBookedTimeRanges =
              props.alreadyBookedTimeRanges.get(selectedDate);
          }
        }

        const valid = scheduleUtils.isTimeValid(
          time,
          selected,
          alreadyBookedTimeRanges,
          validTimeRanges,
          timeFormat,
          sessionTimeLimit,
          props.maxDate,
          selectedTimezone,
          mentorTimeZone,
          minDate,
        );
        return valid;
      };

  const selectedTimeInterval = moment(selected)
    .tz(selectedTimezone)
    .format(timeFormatStr);
  const setTime = (time) => {
    if (isTimeValid(time)) {
      if (setfirstAvailableTimeSlot) setfirstAvailableTimeSlot(time);
      const newTime = new Date(
        moment(time, [timeFormatStr]).tz(selectedTimezone),
      );

      props.onChange(newTime);
    }
  };
  const pickerRef = useRef(null);

  const scrollToSelectedTime = () => {
    let firstAvailableTimeSlot = '';
    let firstAvailableTimeSlotIndex = '';

    if (!selectedTimeInterval) {
      for (let i = 0; i < timesArray.length; i++) {
        if (isTimeValid(timesArray[i])) {
          firstAvailableTimeSlot = timesArray[i];
          firstAvailableTimeSlotIndex = i;
          break;
        }
      }
      if (setfirstAvailableTimeSlot) {
        setfirstAvailableTimeSlot(firstAvailableTimeSlot);
      }
    } else {
      firstAvailableTimeSlot = selectedTimeInterval;
      firstAvailableTimeSlotIndex = timesArray.findIndex(
        (item) => item === selectedTimeInterval,
      );
    }
    pickerRef.current.scrollTop =
      (firstAvailableTimeSlotIndex / timesArray.length) *
        pickerRef.current.scrollHeight -
      pickerRef.current.clientHeight / 2;
  };
  timesArray = timesArray.filter((time) => isTimeValid(time));
  return (
    <TimePickerComponentRender
      pickerRef={pickerRef}
      timesArray={timesArray}
      selectedTimeInterval={selectedTimeInterval}
      setTime={setTime}
    />
  );
};

export default TimePickerComponent;
TimePickerComponent.propTypes = {
  timeFormat: PropTypes.string.isRequired,
  //   defaultValue: PropTypes.string,
};
